import { MessageTemplateForm } from 'src/components/model/messageTemplate/form';

export const MessageTemplateCreateForm: React.FC = () => {
  return <MessageTemplateForm />;
};
